import React from "react";
import { CustomInput } from "../main_comps/custom_input/CustomInput";

const CommissionEditComponent = ({ value, onChange }) => {
  return (
    <CustomInput
      validator={"paise"}
      type={"input"}
      inputStyles={{
        background: "#F6F6F6",
        borderRadius: "4px",
        fontSize: "15px",
        width: "40px",
        color: "#1E2234",
        height: 40,
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
        border: "1px solid #DFDFDF",
        padding: "4px",
        boxSizing: "border-box",
      }}
      onChange={(val) => onChange(val)}
      value={value}
    />
  );
};

export default CommissionEditComponent;
